import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { GeneralService } from 'src/app/services/service.index';
import { UtilHelper } from '../../../_helpers/util';


@Component({
  selector: 'app-rpt-formulacion',
  templateUrl: './rpt-formulacion.component.html',
  styleUrls: []
})
export class RptFormulacionComponent implements OnInit {
  baseUrl = environment.apiEndpoint;
  gestiones: any = [];
  gestion: string = '';
  constructor(private _gs: GeneralService) {
    this.getPoaGestiones();
  }

  ngOnInit() {
  }

  getPoaGestiones() {
    this._gs.getPoaGestiones().subscribe(
      (response) => {
        let result = UtilHelper.responses(response);
        if (result.status == 200) { this.gestiones = result.data; }
        else { this.gestiones = []; }
      },
      (error) => { console.log('Error', error); });
  }
  
  getEtapasByGestionId(e: any) {
    if (e.value != undefined && e.value != null) {
      this._gs.getEtapasByGestionId(e.value).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.gestion = e.value;
          }

        },
        (error) => { console.log('Error', error); });
    }
  }

}
